import React from "react";

export const ExplanationPyramidEs = () => {
  return (
    <>
      <h1 className="text-2xl font-bold text-gray-900 mb-4 mt-4">Cómo Funciona un Esquema Piramidal</h1>
      <h3 className="mt-2"><strong>Paso 1: Se Crea el Esquema</strong></h3>
      <ul>
        <li>Un fundador o líder inicia el esquema y lo presenta como una oportunidad de inversión o negocio.</li>
        <li>A los participantes se les prometen altos rendimientos por reclutar a otros en lugar de vender un producto o servicio.</li>
      </ul>
      <h3 className="mt-2"><strong>Paso 2: Se Unen los Participantes Iniciales</strong></h3>
      <ul>
        <li>Los primeros reclutas invierten dinero para unirse al esquema.</li>
        <li>Su dinero va al fundador o a los miembros de nivel superior.</li>
        <li>Luego se les dice que recluten a otros para ganar rendimientos.</li>
      </ul>

      <h3 className="mt-2"><strong>Paso 3: Crecimiento a través del Reclutamiento</strong></h3>
      <ul>
        <li>Los nuevos reclutas deben pagar para unirse, y su dinero se utiliza para pagar a los miembros anteriores.</li>
        <li>El esquema crece exponencialmente, requiriendo más y más reclutas en cada nivel.</li>
      </ul>
      <h3 className="mt-2"><strong>Paso 4: La Insostenibilidad se Vuelve Obvia</strong></h3>
      <ul>
        <li>Eventualmente, el número de nuevos reclutas disminuye, pero el esquema requiere un crecimiento continuo.</li>
        <li>Los niveles inferiores luchan por reclutar, lo que significa que la mayoría de los participantes pierden su dinero.</li>
      </ul>

      <h3 className="mt-2"><strong>Paso 5: El Colapso</strong></h3>
      <ul>
        <li>Una vez que el reclutamiento se detiene, el flujo de efectivo se agota.</li>
        <li>Aquellos en la base pierden su inversión y el esquema se desmorona.</li>
        <li>Los organizadores principales pueden desaparecer con los fondos restantes, o las autoridades pueden intervenir.</li>
      </ul>
      <h3 className="mt-2"><strong>Señales Clave de un Esquema Piramidal</strong></h3>
      <ul>
        <li>1. Énfasis en reclutar en lugar de vender un producto o servicio real.</li>
        <li>2. Altas tarifas de inversión inicial con promesas de grandes retornos.</li>
        <li>3. Crecimiento matemáticamente insostenible: eventualmente, no hay suficientes personas nuevas para reclutar.</li>
        <li>4. La mayoría de los participantes pierden dinero, beneficiándose solo los miembros de nivel superior.</li>
      </ul>
    </>
  );
};
